import { render, staticRenderFns } from "./TournamentRank.vue?vue&type=template&id=74cbdae8&"
import script from "./TournamentRank.vue?vue&type=script&lang=js&"
export * from "./TournamentRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports